<div class="sk-list" [attr.aria-busy]="true" aria-live="polite">
  <ng-container *ngIf="variant === 'row'">
    <div class="sk-row" *ngFor="let _ of range">
      <div class="sk-shimmer sk-avatar"></div>
      <div class="sk-text">
        <div class="sk-shimmer sk-line sk-line-title"></div>
        <div class="sk-shimmer sk-line sk-line-meta"></div>
      </div>
      <div class="sk-shimmer sk-trailing"></div>
    </div>
  </ng-container>

  <ng-container *ngIf="variant === 'activity'">
    <div class="sk-row sk-row-activity" *ngFor="let _ of range">
      <div class="sk-shimmer sk-dot"></div>
      <div class="sk-shimmer sk-line sk-line-wide"></div>
      <div class="sk-shimmer sk-time"></div>
    </div>
  </ng-container>
</div>
